<div class="label_status" :style="{ 'background': background_color_current, 'borderColor': background_color_current, 'color': color }">{{ label_current }}</div>